import { EventName } from "module/analytics/types"

import { PerpRadioGroup, PerpRadioGroupProps } from "component/PerpRadioGroup"
import { FUNDING_RATE_RESOLUTION } from "service/appSync/FundingRateService"

export const RESOLUTION_OPTIONS: { value: FUNDING_RATE_RESOLUTION; label: string }[] = [
    { value: FUNDING_RATE_RESOLUTION.HOUR_1, label: "1h Rate" },
    { value: FUNDING_RATE_RESOLUTION.HOUR_8, label: "8h Rate" },
    { value: FUNDING_RATE_RESOLUTION.YEAR_1, label: "Annualized" },
]

interface ResolutionOptionsProps extends Omit<PerpRadioGroupProps, "options" | "trackingProps"> {
    defaultValue: FUNDING_RATE_RESOLUTION
}

export const ResolutionOptions = ({ ...perpRadioGroupProps }: ResolutionOptionsProps) => {
    return (
        <PerpRadioGroup
            options={RESOLUTION_OPTIONS}
            trackingProps={{ eventName: EventName.MARKET_DETAIL_FUNDING_RATE_INTERVAL_TOGGLE }}
            {...perpRadioGroupProps}
        />
    )
}
